import { ImageList } from "@mui/material";
import useIsSmallScreen from "../../../hooks/useIsSmallScreen";


const GalleryContainer = (props) => {

    const isSmallScreen = useIsSmallScreen();

    return(
        <ImageList sx={{ 
                width: "90%", 
                height: "auto", 
                margin: "auto", 
                marginTop: "35px" }}
                variant="quilted"
                cols={ isSmallScreen ? 1 : 3 }
                rowHeight="auto"
                gap={8}>
            
            {props.children}
        </ImageList>
    );
}

export default GalleryContainer;